export default __webpack_public_path__ + "static/media/down-arrow.d89dc5da.svg";